export default __webpack_public_path__ + "static/assets/med_pill_square_flat_L0_solid_l_01_f_mask.c0fd8182.png";